import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, Alert, Layout, Row, Col } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Content } = Layout;

interface AdminLoginProps {
  onLoginSuccess: (token: string) => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || '登录失败');
      }
      
      const data = await response.json();
      
      // 存储token
      localStorage.setItem('admin_token', data.access_token);
      localStorage.setItem('admin_token_expiry', 
        (Date.now() + data.expires_in * 1000).toString()
      );
      
      // 调用成功回调
      onLoginSuccess(data.access_token);
      
      // 跳转到管理页面或来源页面
      const from = (location.state as any)?.from?.pathname || '/admin';
      navigate(from, { replace: true });
      
    } catch (err: any) {
      setError(err.message || '登录失败，请检查用户名和密码');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Row justify="center" align="middle" style={{ width: '100%' }}>
          <Col xs={24} sm={16} md={12} lg={8}>
            <Card 
              style={{ 
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                borderTop: '4px solid #d32f2f'
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <Title level={3} style={{ color: '#d32f2f' }}>
                  管理员登录
                </Title>
                <p style={{ color: '#666' }}>请输入管理员账号和密码</p>
              </div>
              
              {error && (
                <Alert
                  message={error}
                  type="error"
                  showIcon
                  style={{ marginBottom: '24px' }}
                  closable
                  onClose={() => setError(null)}
                />
              )}
              
              <Form
                name="admin_login"
                onFinish={onFinish}
                layout="vertical"
                initialValues={{ username: 'admin' }}
              >
                <Form.Item
                  name="username"
                  label="用户名"
                  rules={[{ required: true, message: '请输入用户名' }]}
                >
                  <Input 
                    prefix={<UserOutlined />} 
                    placeholder="admin" 
                    size="large"
                  />
                </Form.Item>
                
                <Form.Item
                  name="password"
                  label="密码"
                  rules={[{ required: true, message: '请输入密码' }]}
                >
                  <Input.Password 
                    prefix={<LockOutlined />} 
                    placeholder="请输入密码" 
                    size="large"
                  />
                </Form.Item>
                
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                    size="large"
                    style={{
                      background: '#d32f2f',
                      borderColor: '#d32f2f',
                      height: '48px',
                      fontSize: '16px',
                      fontWeight: 'bold'
                    }}
                  >
                    登录
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default AdminLogin;
